import { View, Text, StyleSheet } from '@react-pdf/renderer';

import QuoLogo from './Logo';
import { PDF_COLORS, PDF_FONT_FAMILY } from './styles';

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: PDF_COLORS.cardSurface,
    paddingHorizontal: 30,
    paddingVertical: 14,
  },
  tagline: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  taglineLeft: {
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 700,
    fontSize: 10,
    color: PDF_COLORS.brandTagline,
    marginRight: 6,
    letterSpacing: 0.3,
  },
  taglinePill: {
    backgroundColor: PDF_COLORS.brandAccent,
    color: PDF_COLORS.brandAccentText,
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 700,
    fontSize: 10,
    letterSpacing: 0.3,
    paddingHorizontal: 6,
    paddingVertical: 3,
  },
});

const Header = () => (
  <View style={styles.wrapper} fixed>
    <QuoLogo width={150} height={22} />

    <View style={styles.tagline}>
      <Text style={styles.taglineLeft}>KNOW YOUR RISK.</Text>
      <Text style={styles.taglinePill}>ACT BEFORE IT MOVES.</Text>
    </View>
  </View>
);

export default Header;
